import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import showToastMessage from "../global/showToastMessage";
import { irdStatusQueryKey, postCheckIrdStatus } from "../queries/bill.queries";

function readStoredIrdStatus(): boolean {
	const stored = localStorage.getItem("irdStatus");
	return stored === null ? true : JSON.parse(stored);
}

// Dedupes the billServerStatusReducer selector + checkIRDStatus dispatch
// previously copy-pasted across invoice-form, ready-draft-list,
// top-navigation, and error-fix.page. Public shape is unchanged from the
// Redux-backed version this replaces — billServerStatusReducer itself is
// gone, superseded by this query-cache-backed source (see
// migration-query-typescript memory for the removal writeup).
export function useIrdStatus() {
	const queryClient = useQueryClient();

	const { data: irdStatus } = useQuery({
		queryKey: irdStatusQueryKey,
		queryFn: () => Promise.resolve(readStoredIrdStatus()),
		staleTime: Infinity,
		gcTime: Infinity,
	});

	const mutation = useMutation({
		mutationFn: postCheckIrdStatus,
		onSuccess: ({ status, message }) => {
			showToastMessage(message, "I");
			queryClient.setQueryData(irdStatusQueryKey, status);
			localStorage.setItem("irdStatus", JSON.stringify(status));
		},
	});

	return {
		irdStatus: irdStatus ?? true,
		irdStatusLoading: mutation.isPending,
		checkStatus: mutation.mutateAsync,
	};
}
